export const UseGetProcessesEnabled = !import.meta.env.DEV;
export const NoPlanSelectedDialogEnabled = !import.meta.env.DEV;

// Useful for debugging
// Make everything disabled
export const FEATURE_TOGGLE_GLOBAL_DEBUG = true;

// Set to false to see features as a 'member'
export const ADMINS_HAVE_FULL_ACCESS = true;
